import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { WorkflowExecutionStatus } from '../constants/enums';
import { t } from '../i18n/i18n';

export const getStatusConfig = (status) => {
  switch (status) {
    case WorkflowExecutionStatus.PENDING:
      return {
        color: 'orange',
        icon: <ClockCircleOutlined />,
        text: t('ALKYMATION_STATUS_PENDING'),
        bgColor: '#fff7e6',
        borderColor: '#ffa940',
      };
    case WorkflowExecutionStatus.RUNNING:
      return {
        color: 'blue',
        icon: <LoadingOutlined spin />,
        text: t('ALKYMATION_STATUS_RUNNING'),
        bgColor: '#e6f7ff',
        borderColor: '#40a9ff',
      };
    case WorkflowExecutionStatus.COMPLETED:
      return {
        color: 'green',
        icon: <CheckCircleOutlined />,
        text: t('ALKYMATION_STATUS_COMPLETED'),
        bgColor: '#f6ffed',
        borderColor: '#52c41a',
      };
    case WorkflowExecutionStatus.FAILED:
      return {
        color: 'red',
        icon: <CloseCircleOutlined />,
        text: t('ALKYMATION_STATUS_FAILED'),
        bgColor: '#fff2f0',
        borderColor: '#ff4d4f',
      };
    case WorkflowExecutionStatus.CANCELLED:
      return {
        color: 'gray',
        icon: <StopOutlined />,
        text: t('ALKYMATION_STATUS_CANCELLED'),
        bgColor: '#fafafa',
        borderColor: '#d9d9d9',
      };
    default:
      return {
        color: 'default',
        icon: <ClockCircleOutlined />,
        text: status,
        bgColor: '#fafafa',
        borderColor: '#d9d9d9',
      };
  }
};

export const calculateDuration = (startDate, endDate) => {
  if (!startDate || !endDate) return null;
  const duration = Math.round((new Date(endDate) - new Date(startDate)) / 1000);

  if (duration < 60) {
    return `${duration}s`;
  }
  if (duration < 3600) {
    return `${Math.round(duration / 60)}m`;
  }
  const hours = Math.floor(duration / 3600);
  const minutes = Math.round((duration % 3600) / 60);
  return `${hours}h ${minutes}m`;
};
